import * as S from "./styles.ts";
import { useState } from "react";
import { ColorKey } from "@template/theme/types/color.type.ts";
import { InputLabel } from "@template/components/Input/styles.ts";

export interface ISwitchProps {
  checked?: boolean;
  onChange?: (checked: boolean, e?: any) => void;
  disabled?: boolean;
  label?: string;
  name?: string;
  wrapperProps?: any;
  color?: ColorKey;
  variant?: "flat" | "light";
}

const Switch = ({
                  checked,
                  onChange,
                  disabled,
                  label,
                  name,
                  wrapperProps,
                  color = "primary",
                  variant = "light",
                }: ISwitchProps) => {
  const [defaultChecked, setDefaultChecked] = useState(false);
  const usedChecked = typeof checked === "boolean" ? checked : defaultChecked;
  const usedOnChange = onChange !== undefined ? onChange : setDefaultChecked;

  const handleChange = (e: any) => {
    if (disabled) return;
    usedOnChange(!usedChecked, e);
  };

  return (
    <S.Wrapper
      onClick={handleChange}
      $variant={variant}
      {...wrapperProps}
      style={{
        cursor: disabled ? "default" : "pointer",
        ...(wrapperProps?.style ? wrapperProps.style : {}),
      }}
    >
      {label && (
        <InputLabel
          style={{
            cursor: disabled ? "default" : "pointer",
          }}
        >
          {label}
        </InputLabel>
      )}
      <S.SwitchContainer>
        <S.GhostInput
          type="checkbox"
          checked={usedChecked}
          name={name || label}
          disabled={disabled}
          onChange={handleChange}
        />
        <S.InputStyle
          $checked={usedChecked}
          $disabled={disabled}
          $color={color}
        />
      </S.SwitchContainer>
    </S.Wrapper>
  );
};

export default Switch;
